import React from "react";
import "../styles/WhyChooseUs.css";
import { Award, Users, Headphones, TrendingUp } from "lucide-react";

const WhyChooseUs = () => {
  const features = [
    {
      title: "Expert Partnerships",
      description:
        "Our close collaboration with industry leaders gives you access to the latest tools, updates, and best practices.",
      icon: <Users className="feature-icon" size={32} />,
    },
    {
      title: "Comprehensive Expertise",
      description:
        "With deep technical knowledge, we offer customized solutions that are tailored to meet your unique business goals and challenges.",
      icon: <Award className="feature-icon" size={32} />,
    },
    {
      title: "End-to-End Support",
      description:
        "From consultation through implementation and beyond, we provide support every step of the way.",
      icon: <Headphones className="feature-icon" size={32} />,
    },
    {
      title: "Proven Results",
      description:
        "Combining technology with strategy, we deliver tangible outcomes that drive real transformation for businesses.",
      icon: <TrendingUp className="feature-icon" size={32} />,
    },
  ];

  return (
    <section className="why-choose-us">
      <div className="background-pattern"></div>
      <div className="container">
        <div className="why-choose-us-header">
          <h2>Why Choose Us?</h2>
          <div className="underline"></div>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="icon-wrapper">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
